import { render, staticRenderFns } from "./pickup-phone.vue?vue&type=template&id=0affd67c&scoped=true"
import script from "./pickup-phone.vue?vue&type=script&lang=ts"
export * from "./pickup-phone.vue?vue&type=script&lang=ts"
import style0 from "./pickup-phone.vue?vue&type=style&index=0&id=0affd67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affd67c",
  null
  
)

export default component.exports